import {
  Box,
  Grid,
  Typography,
  Container,
  Avatar,
} from '@mui/material';

function PrintHeader() {
  return (
    <Container>
      <Grid
        container
        spacing={0}
        direction="row"
        justifyContent="center"
      >
        <Box sx={{ marginTop: 4 }}>
          <Grid
            container
            spacing={0}
            direction="row"
            justifyContent="center"
          >
            <Box>
              <Avatar
                alt="Rewot banner"
                variant="square"
                src="/static/images/rewot_banner.jpeg"
                sx={{ width: 200, height: 100 }}
              />
            </Box>
          </Grid>
          {/* <Typography variant="h4">Onboard for executive solutions</Typography> */}
        </Box>
      </Grid>

      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Box sx={{ paddingLeft: 8, paddingTop: 4 }}>
            <Typography variant="h6">Keekorok Building No. 30, 1ST FLR</Typography>
            <Typography variant="h6">P.O BOX 15073-00400 </Typography>
            <Typography variant="h6">Nairobi, Kenya</Typography>
          </Box>

        </Grid>
        <Grid item xs={6}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Box sx={{ paddingRight: 8, paddingTop: 4 }}>
              <Typography variant="h6">Contacts: +254 715464554</Typography>
              <Typography variant="h6">Email: info@rewotciro.co.ke</Typography>
              <Typography variant="h6">
                Website:
                <a href="www.rewotciro.co.ke"> www.rewotciro.co.ke </a>
              </Typography>
            </Box>

          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default PrintHeader;
